var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit, Prop } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import MessageContactList from '~/components/smart-collection/message-collection/message-contact-list.vue';
import { SmartCollectionService } from "~/services/domain-service/smart-collection.service";
import { TemplateService } from '~/services/domain-service/template.service';
var MessageCollectionModule = namespace('message-collection');
var MessageSendList = /** @class */ (function (_super) {
    __extends(MessageSendList, _super);
    function MessageSendList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.templateSet = [];
        _this.model = {
            overduePeriod: '',
            templateId: '',
            messageContent: '',
        };
        return _this;
    }
    MessageSendList.prototype.refreshData = function () {
        var form = this.$refs['form'];
        form.resetFields();
        var instance = this.$refs['message-contact-list'];
        instance.refreshData();
        this.onOverduePeriodChange("");
    };
    MessageSendList.prototype.back = function () {
        var form = this.$refs['form'];
        form.resetFields();
    };
    MessageSendList.prototype.close = function () { };
    /**
     * 数据列表改变
     */
    MessageSendList.prototype.onChange = function (val) {
        this.dataSet = val || [];
    };
    /**
     * 逾期阶段改变
     */
    MessageSendList.prototype.onOverduePeriodChange = function (overduePeriod) {
        var _this = this;
        if (overduePeriod) {
            this.templateService.getTemplateByOverduePeriod({ overduePeriod: overduePeriod, templateCategory: "MESSAGE" }).subscribe(function (data) { return _this.templateSet = data || []; });
        }
        else {
            this.templateService.getTemplateByOverduePeriod({ templateCategory: "MESSAGE" }).subscribe(function (data) { return _this.templateSet = data || []; });
        }
        this.onTemplateChange('');
    };
    /**
     * 模板改变
     */
    MessageSendList.prototype.onTemplateChange = function (templateId) {
        var templateContent = '';
        if (templateId) {
            var template = this.templateSet.find(function (v) { return v.id === templateId; });
            templateContent = template.templateContent;
        }
        this.model.templateId = templateId;
        this.model.messageContent = templateContent;
    };
    /**
     * 发送
     */
    MessageSendList.prototype.submit = function () {
        var _this = this;
        if (this.dataSet.length === 0) {
            this.$message.warning('数据为空,不能发送');
            return;
        }
        var form = this.$refs['form'];
        form.validate(function (v) {
            if (!v)
                return;
            var sendMessage = _this.caseIdList.map(function (v) {
                var arr = _this.dataSet.filter(function (e) { return e.caseId === v; }) || [];
                return {
                    caseId: v,
                    contIds: arr.map(function (d) { return d.id; }) || []
                };
            });
            var request = {
                templateId: _this.model.templateId,
                sendMessageRequests: sendMessage,
            };
            _this.smartCollectionService.batchSendMessage(request).subscribe(function (data) {
                _this.close();
                _this.$message.success('发送成功');
            });
        });
    };
    __decorate([
        Dependencies(SmartCollectionService)
    ], MessageSendList.prototype, "smartCollectionService", void 0);
    __decorate([
        Dependencies(TemplateService)
    ], MessageSendList.prototype, "templateService", void 0);
    __decorate([
        MessageCollectionModule.State
    ], MessageSendList.prototype, "caseIdList", void 0);
    __decorate([
        Prop()
    ], MessageSendList.prototype, "sendTarget", void 0);
    __decorate([
        Emit('on-back')
    ], MessageSendList.prototype, "back", null);
    __decorate([
        Emit('on-close')
    ], MessageSendList.prototype, "close", null);
    MessageSendList = __decorate([
        Component({
            components: {
                MessageContactList: MessageContactList
            }
        })
    ], MessageSendList);
    return MessageSendList;
}(Vue));
export default MessageSendList;
